import { __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import JsxComponent from '@slickdeals/blueprint-twig/javascript/core/jsxComponent';
import CashbackJoinModal from './_cashbackJoinModal';
export const name = 'CashbackJoinModalContextService';
let CashbackJoinModalContextService = class CashbackJoinModalContextService {
    initModalContext() {
        return (JsxComponent.parseJsx(CashbackJoinModal, null));
    }
};
CashbackJoinModalContextService = __decorate([
    injectable(name)
], CashbackJoinModalContextService);
export default CashbackJoinModalContextService;
